/* MT — interacciones propias. Cada init comprueba si su elemento existe. */
(function () {
  // Varias secciones cargan este archivo: solo debe ejecutarse una vez por página
  if (window.__mtScripts) return;
  window.__mtScripts = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-zoom');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-mt-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-mt-count')) || 0;
      var dec = (String(to).split('.')[1] || '').length;
      if (reduce) { el.textContent = to.toFixed(dec).replace('.', ','); return; }
      var t0 = null, dur = 1600;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = to * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-mt-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-compare]');
    var saveEl = root.querySelector('[data-mt-save]');
    var btn = root.querySelector('[data-mt-add]');
    var btnLabel = btn ? btn.getAttribute('data-label') : '';
    var soldLabel = btn ? btn.getAttribute('data-sold') : '';
    var stickyPrice = document.querySelector('[data-mt-sticky-price]');
    var money = root.getAttribute('data-money') || '{{amount_with_comma_separator}} €';

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      var withDot = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var withComma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
      return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k.indexOf('comma') > -1) return withComma;
        if (k.indexOf('no_decimals') > -1) return Math.round(cents / 100);
        return withDot;
      });
    }

    function selected() {
      var opts = [];
      root.querySelectorAll('[data-mt-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        opts.push(c ? c.value : null);
        var lbl = fs.querySelector('[data-mt-option-value]');
        if (lbl && c) lbl.textContent = c.value;
      });
      return opts;
    }

    function update(inicial) {
      var opts = selected();
      var v = variants.find(function (vv) { return vv.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = soldLabel; } return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = fmt(v.compare_at_price); compareEl.hidden = false;
          if (saveEl) { saveEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; saveEl.hidden = false; }
        } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
      }
      if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btnLabel : soldLabel; }
      updatePack(v);
      if (inicial === true) return;
      if (v.featured_media) showMedia(String(v.featured_media.id));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-mt-option] input').forEach(function (i) { i.addEventListener('change', function () { update(false); }); });

    // Pack de 2 unidades (precios reales: 2 x precio unitario, menos el ahorro del descuento automático)
    var pack = root.querySelector('[data-mt-pack]');
    var packSecond = root.querySelector('[data-mt-pack-second]');
    var packSelect = root.querySelector('[data-mt-pack-select]');
    var qtyBox = root.querySelector('.mt-qty');
    function packMode() { var r = pack && pack.querySelector('input[name="mt-pack"]:checked'); return r ? r.value : '1'; }
    function updatePack(v) {
      if (!pack || !v) return;
      var ahorro = parseInt(pack.getAttribute('data-ahorro'), 10) || 0;
      var one = pack.querySelector('[data-mt-pack-one]'), two = pack.querySelector('[data-mt-pack-two]');
      var was = pack.querySelector('[data-mt-pack-was]'), save = pack.querySelector('[data-mt-pack-save]');
      if (one) one.textContent = fmt(v.price);
      if (was) was.textContent = fmt(v.price * 2);
      if (two) two.textContent = fmt(v.price * 2 - ahorro * 2);
      if (save) save.textContent = 'Ahorras ' + fmt(ahorro * 2);
      if (packSelect && packMode() === '1') packSelect.value = String(v.id);
    }
    function applyPackMode() {
      var two = packMode() === '2';
      if (packSecond) packSecond.hidden = !two;
      if (qtyBox) qtyBox.style.display = two ? 'none' : '';
    }
    if (pack) pack.querySelectorAll('input[name="mt-pack"]').forEach(function (r) { r.addEventListener('change', applyPackMode); });

    // Galería
    var main = root.querySelector('[data-mt-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mt-thumb]'));
    var current = 0;
    function show(i) {
      if (!main || !thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      main.classList.add('is-fading');
      setTimeout(function () {
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        main.classList.remove('is-fading');
      }, 220);
    }
    function showMedia(id) {
      var i = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') === id; });
      if (i > -1 && i !== current) show(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-mt-prev]'), next = root.querySelector('[data-mt-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }

    // Cantidad
    var qty = root.querySelector('[data-mt-qty]');
    if (qty) {
      root.querySelector('[data-mt-minus]').addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      root.querySelector('[data-mt-plus]').addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Añadir al carrito: se añade y se va al carrito
    var form = root.querySelector('form[action*="/cart/add"]');
    var errEl = root.querySelector('[data-mt-error]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.disabled = true;
        var body = new FormData(form), headers = { 'Accept': 'application/json' };
        if (pack && packMode() === '2') {
          var a = idInput.value, b = packSelect ? packSelect.value : a;
          var items = a === b ? [{ id: +a, quantity: 2 }] : [{ id: +a, quantity: 1 }, { id: +b, quantity: 1 }];
          body = JSON.stringify({ items: items });
          headers['Content-Type'] = 'application/json';
        }
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: headers, body: body
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { if (errEl) errEl.textContent = res.j.description || res.j.message || 'No se pudo añadir.'; if (btn) btn.disabled = false; return; }
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          })
          .catch(function () { form.submit(); });
      });
    }

    // Barra fija en móvil
    var bar = document.querySelector('[data-mt-sticky-bar]');
    if (bar && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(btn);
      bar.querySelector('button').addEventListener('click', function () { btn.click(); });
    }

    // Estado inicial (sin mover la galería ni tocar la URL)
    update(true);
  }

  /* ---------- Comparador antes / después ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-mt-ba]').forEach(function (ba) {
      if (ba.dataset.mtReady) return;
      ba.dataset.mtReady = '1';
      var range = ba.querySelector('.mt-ba__range');
      if (!range) return;
      function set(v) { ba.style.setProperty('--mt-pos-x', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
      // Pequeño "guiño" al aparecer para invitar a arrastrar
      if (reduce || ba.getAttribute('data-anim') === 'false' || !('IntersectionObserver' in window)) return;
      var start = parseFloat(range.value);
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1800, 1);
          var v = start + Math.sin(p * Math.PI * 2) * 14 * (1 - p);
          range.value = v; set(v);
          if (p < 1) requestAnimationFrame(step); else { range.value = start; set(start); }
        }
        setTimeout(function () { requestAnimationFrame(step); }, 500);
      }, { threshold: 0.5 });
      io.observe(ba);
    });
  }

  /* ---------- Calculadora de ahorro ---------- */
  function initCalc() {
    document.querySelectorAll('[data-mt-calc]').forEach(function (box) {
      if (box.dataset.mtReady) return;
      box.dataset.mtReady = '1';
      var money = box.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      var prod = parseFloat(String(box.getAttribute('data-producto')).replace(',', '.')) || 0;
      var range = box.querySelector('[data-mt-calc-precio]');
      var out = box.querySelector('[data-mt-calc-out]');
      var btns = box.querySelectorAll('[data-mt-calc-freq]');
      var freq = 2;
      btns.forEach(function (b) { if (b.classList.contains('is-on')) freq = parseInt(b.getAttribute('data-mt-calc-freq'), 10); });
      function fmt(eur) {
        var cents = Math.round(eur * 100);
        var v = (cents / 100).toFixed(2);
        var comma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
        return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k.indexOf('comma') > -1) return comma;
          if (k.indexOf('no_decimals') > -1) return Math.round(eur);
          return v;
        });
      }
      function calc() {
        var precio = parseFloat(range.value) || 0;
        var visitas = 12 / freq;
        var gasto = precio * visitas;
        var ahorro = Math.max(gasto - prod, 0);
        out.textContent = precio + ' €';
        range.style.setProperty('--mt-fill', ((precio - range.min) / (range.max - range.min) * 100) + '%');
        box.querySelector('[data-mt-calc-visitas]').textContent = (visitas % 1 ? visitas.toFixed(1).replace('.', ',') : visitas);
        box.querySelector('[data-mt-calc-gasto]').textContent = fmt(gasto);
        box.querySelector('[data-mt-calc-prod]').textContent = fmt(prod);
        box.querySelector('[data-mt-calc-ahorro]').textContent = fmt(ahorro);
      }
      range.addEventListener('input', calc);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
          freq = parseInt(b.getAttribute('data-mt-calc-freq'), 10); calc();
        });
      });
      calc();
    });
  }

  /* ---------- Ventana de bienvenida (10%) ---------- */
  function initPopup() {
    var pop = document.querySelector('[data-mt-pop]');
    if (!pop || pop.dataset.mtReady) return;
    pop.dataset.mtReady = '1';
    var KEY = 'mt-pop-cerrada', SUB = 'mt-pop-suscrita';
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function open() { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); }
    function close() {
      pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
      var dias = parseInt(pop.getAttribute('data-dias'), 10) || 14;
      set(KEY, String(Date.now() + dias * 864e5));
    }
    pop.querySelectorAll('[data-mt-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    // Cualquier botón "10%" de la página abre la ventana
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-mt-pop-open]');
      if (t) { e.preventDefault(); open(); }
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    var copy = pop.querySelector('[data-mt-pop-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = pop.querySelector('[data-mt-pop-code]').textContent.trim();
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      copy.textContent = copy.getAttribute('data-ok');
    });
    // Tras enviar el formulario (éxito o error) se vuelve a abrir para mostrar el resultado
    if (pop.querySelector('[data-mt-pop-ok]')) { set(SUB, '1'); open(); return; }
    if (pop.querySelector('[data-mt-pop-err]')) { open(); return; }
    if (pop.getAttribute('data-design') === 'true') return;
    if (get(SUB) === '1') return;
    var hasta = parseInt(get(KEY), 10);
    if (hasta && hasta > Date.now()) return;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 10) * 1000;
    setTimeout(open, delay);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initCountUp(); initParallax(); initProduct(); initBeforeAfter(); initCalc(); initPopup();
  });
  document.addEventListener('shopify:section:load', function () { initReveal(); initCountUp(); initBeforeAfter(); initCalc(); });
  // En el editor de Shopify: al seleccionar la ventana de bienvenida, se abre para poder verla
  document.addEventListener('shopify:section:select', function (e) {
    var pop = e.target && e.target.querySelector && e.target.querySelector('[data-mt-pop]');
    if (pop) { initPopup(); pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pop = e.target && e.target.querySelector && e.target.querySelector('[data-mt-pop]');
    if (pop) { pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true'); }
  });
})();
